import React from "react";
import { Card } from "react-bootstrap";
import { Settings } from "react-feather";

const UserOverviewWidgetWrapper = ({ title, handleSettings, children }) => {
  return (
    <React.Fragment>
      <Card className="p-3 border border-1">
        <Card.Title>
          <div className="d-flex justify-content-between">
            <div>{title}</div>
            {handleSettings && (
              <Settings
                size={18}
                className="align-middle cursor-pointer"
                onClick={handleSettings}
              />
            )}
          </div>
        </Card.Title>
        <Card.Body
          className="p-0 pt-2"
          style={{ minHeight: "180px", maxHeight: "600px", overflowY: "auto" }}
        >
          {children}
        </Card.Body>
      </Card>
    </React.Fragment>
  );
};

export default UserOverviewWidgetWrapper;
